module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont-25a324.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.eot?v=4.6.3
// module id = 804
// module chunks = 2